import PalavraChave from './PalavraChave';
import TituloSeo from './TituloSeo';
import Slug from './Slug';
import Permalink from './Permalink';
import AltImagem from './AltImagem';
import MetaDescription from './MetaDescription';
import Breadcrumbs from './Breadcrumbs';
import PreVisualizacao from './PreVisualizacao';
import Autor from './Autor';
import CardAnalise from '@componentsNew/Analises/CardAnalises';
import { useContext, useEffect } from '@wordpress/element';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

function EstruturaPost() {
  const { obterMetadados, carregando, estrutura } = useContext(EstruturaPostContext);

  useEffect(() => {
    obterMetadados();
  }, []);

  return (
    <CardAnalise
      titulo="Estrutura do artigo"
      subTitulo="Avaliação da estrutura"
      nota={
        Object.keys(estrutura || {}).reduce((acc, key) => acc + (estrutura?.[key]?.valor || 0), 0) /
        Object.keys(estrutura || {}).length
      }
    >
      <div className="h-[27em] overflow-y-auto pb-3">
        <PalavraChave
          carregando={carregando}
          nota={estrutura.palavra_chave}
        />
        <TituloSeo
          carregando={carregando}
          nota={estrutura.title_seo}
        />
        <Slug
          carregando={carregando}
          nota={estrutura.slug}
        />
        <Permalink
          carregando={carregando}
          nota={estrutura.link_permanente}
        />
        <MetaDescription
          carregando={carregando}
          nota={estrutura.meta_descricao}
        />
        <AltImagem
          carregando={carregando}
          nota={estrutura.alt_imagem}
        />
        <Autor
          carregando={carregando}
          nota={estrutura.autor}
        />
        <PreVisualizacao nota={estrutura.pre_visualizacao} />
        <Breadcrumbs
          carregando={carregando}
          nota={estrutura.breadcrumbs}
        />
      </div>
    </CardAnalise>
  );
}

export default EstruturaPost;
